import { prospectInitialState } from './prospect.initialState';
import { SET_SORT_BY, CLEAR_SORT_BY } from './prospect.action';

export const prospectReducer = (state = prospectInitialState, action) => {
	switch (action.type) {
		case CLEAR_SORT_BY: {
			return {
				...state,
				sortBy: prospectInitialState.sortBy,
			};
		}

		case SET_SORT_BY: {
			return {
				...state,
				[action.payload.sortKey]: action.payload.sortValue,
			};
		}

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/redux/prospects/prospect.reducer.js